import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    console.log('Changing language to:', lng);
    i18n.changeLanguage(lng).then(() => {
      localStorage.setItem('language', lng);
      console.log('Language changed to:', i18n.language);
      // Force re-render by updating document language
      document.documentElement.lang = lng;
    });
  };

  const currentLang = i18n.language?.substring(0, 2) || 'en';

  return (
    <div className="flex items-center gap-1" data-testid="language-switcher">
      <Button
        variant="ghost"
        size="sm"
        type="button"
        data-testid="lang-en-btn"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          changeLanguage('en');
        }}
        className={`p-2 hover:bg-white/10 transition-opacity ${currentLang === 'en' ? 'opacity-100 ring-2 ring-[#007AFF] rounded' : 'opacity-50'}`}
        title="English"
      >
        <img 
          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 30'%3E%3Cpath fill='%23012169' d='M0 0h60v30H0z'/%3E%3Cpath d='m0 0 60 30m0-30L0 30' stroke='%23fff' stroke-width='6'/%3E%3Cpath d='m0 0 60 30m0-30L0 30' stroke='%23C8102E' stroke-width='4' clip-path='polygon(30 15, 60 0, 60 5.5, 35.5 15)'/%3E%3Cpath d='m0 0 60 30m0-30L0 30' stroke='%23C8102E' stroke-width='4' clip-path='polygon(30 15, 0 30, 0 24.5, 24.5 15)'/%3E%3Cpath d='m0 0 60 30m0-30L0 30' stroke='%23C8102E' stroke-width='4' clip-path='polygon(30 15, 0 0, 0 5.5, 24.5 15)'/%3E%3Cpath d='m0 0 60 30m0-30L0 30' stroke='%23C8102E' stroke-width='4' clip-path='polygon(30 15, 60 30, 60 24.5, 35.5 15)'/%3E%3Cpath d='M30 0v30M0 15h60' stroke='%23FFF' stroke-width='10'/%3E%3Cpath d='M30 0v30M0 15h60' stroke='%23C8102E' stroke-width='6'/%3E%3C/svg%3E"
          alt="EN"
          className="w-7 h-5 rounded pointer-events-none"
        />
      </Button>
      <Button
        variant="ghost"
        size="sm"
        type="button"
        data-testid="lang-de-btn"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          changeLanguage('de');
        }}
        className={`p-2 hover:bg-white/10 transition-opacity ${currentLang === 'de' ? 'opacity-100 ring-2 ring-[#007AFF] rounded' : 'opacity-50'}`}
        title="Deutsch (Österreich)"
      >
        <img 
          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3E%3Crect fill='%23ED2939' width='900' height='200'/%3E%3Crect fill='%23fff' y='200' width='900' height='200'/%3E%3Crect fill='%23ED2939' y='400' width='900' height='200'/%3E%3C/svg%3E"
          alt="AT"
          className="w-7 h-5 rounded pointer-events-none"
        />
      </Button>
    </div>
  );
}

export default LanguageSwitcher;